export default __webpack_public_path__ + "static/media/envelope.90d568c6.svg";